import React from "react";
import { StyledDashedLine } from "./styles";

export const DashedLine = ({ gap = 11, width = 10, height = 1, ...rest }) => {
  return (
    <StyledDashedLine
      className="HubDashedLine-root"
      gap={gap}
      width={width}
      height={height}
      role="separator"
      {...rest}
    />
  );
};

export default DashedLine;
